import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUnitMatrixParametersQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type GetUnitMatrixParametersQuery = { __typename?: 'Query', unit?: { __typename?: 'Unit', id: string, effectiveImpedanceReferencePoint?: Types.EffectiveImpedanceReferencePoint | null, temporaryMinimumPerformance?: number | null, grantAccessToMatrixParametersRoles?: Array<Types.TenantRole> | null, grantAccessToMatrixParametersTenantIds?: Array<string> | null, matrixType?: Types.MatrixType | null, inertiaParameters?: { __typename?: 'InertiaParameters', taGen: number, taZus: number, taGes: number } | null, matrixParameters?: { __typename?: 'MatrixParameters', zwValues: Array<number>, taMin?: { __typename?: 'TimePowerParameters', pMinDyn: number, pMaxDyn: number, pGrenzNegMin: number, pGrenzNegMax: number, pGrenzPosMin: number, pGrenzPosMax: number, taValue: number, effectiveImpedances: Array<boolean> } | null, taMax?: { __typename?: 'TimePowerParameters', pMinDyn: number, pMaxDyn: number, pGrenzNegMin: number, pGrenzNegMax: number, pGrenzPosMin: number, pGrenzPosMax: number, taValue: number, effectiveImpedances: Array<boolean> } | null, taRange?: Array<{ __typename?: 'TimePowerParameters', pMinDyn: number, pMaxDyn: number, pGrenzNegMin: number, pGrenzNegMax: number, pGrenzPosMin: number, pGrenzPosMax: number, taValue: number, effectiveImpedances: Array<boolean> }> | null } | null } | null };


        export type ExecGetUnitMatrixParametersOptions = Omit<
        Apollo.QueryOptions<
        GetUnitMatrixParametersQueryVariables, GetUnitMatrixParametersQuery
        >,
        "query"
      >;
    export const execGetUnitMatrixParametersQuery = (options: ExecGetUnitMatrixParametersOptions) =>
    client.query< GetUnitMatrixParametersQuery, GetUnitMatrixParametersQueryVariables>({
      ...options,
      query: GetUnitMatrixParametersDocument,
    });
    

export const GetUnitMatrixParametersDocument = gql`
    query getUnitMatrixParameters($id: UUID!) {
  unit(id: $id) {
    id
    effectiveImpedanceReferencePoint
    temporaryMinimumPerformance
    grantAccessToMatrixParametersRoles
    grantAccessToMatrixParametersTenantIds
    matrixType
    inertiaParameters {
      taGen
      taZus
      taGes
    }
    matrixParameters {
      taMin {
        pMinDyn
        pMaxDyn
        pGrenzNegMin
        pGrenzNegMax
        pGrenzPosMin
        pGrenzPosMax
        taValue
        effectiveImpedances
      }
      taMax {
        pMinDyn
        pMaxDyn
        pGrenzNegMin
        pGrenzNegMax
        pGrenzPosMin
        pGrenzPosMax
        taValue
        effectiveImpedances
      }
      taRange {
        pMinDyn
        pMaxDyn
        pGrenzNegMin
        pGrenzNegMax
        pGrenzPosMin
        pGrenzPosMax
        taValue
        effectiveImpedances
      }
      zwValues
    }
  }
}
    `;

/**
 * __useGetUnitMatrixParametersQuery__
 *
 * To run a query within a React component, call `useGetUnitMatrixParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitMatrixParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitMatrixParametersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUnitMatrixParametersQuery(baseOptions: Apollo.QueryHookOptions<GetUnitMatrixParametersQuery, GetUnitMatrixParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitMatrixParametersQuery, GetUnitMatrixParametersQueryVariables>(GetUnitMatrixParametersDocument, options);
      }
export function useGetUnitMatrixParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitMatrixParametersQuery, GetUnitMatrixParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitMatrixParametersQuery, GetUnitMatrixParametersQueryVariables>(GetUnitMatrixParametersDocument, options);
        }
export type GetUnitMatrixParametersQueryHookResult = ReturnType<typeof useGetUnitMatrixParametersQuery>;
export type GetUnitMatrixParametersLazyQueryHookResult = ReturnType<typeof useGetUnitMatrixParametersLazyQuery>;
export type GetUnitMatrixParametersQueryResult = Apollo.QueryResult<GetUnitMatrixParametersQuery, GetUnitMatrixParametersQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;